import { Action } from 'redux';

export enum ActionType {
  ToggleOpen = 'Settings.ToggleOpen',
}

export interface ISettingsAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  isOpen: boolean;
}

const INITIAL_STATE: IState = {
  isOpen: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: ISettingsAction): IState {
  switch (action.type) {
    case ActionType.ToggleOpen:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}

export const toggleOpen = () => ({
  type: ActionType.ToggleOpen,
});
